// Standard sale method: products carry `sale: { percent, ends }`. The discount is shown on the
// site (original struck through + green sale price) AND applied automatically at checkout.
// Returns the sale object only while active (before `ends`), else null.
export const activeSale = (product) => {
  const s = product?.sale;
  if (!s || !s.percent) return null;
  if (s.starts && Date.now() < new Date(s.starts).getTime()) return null;
  if (s.ends && Date.now() > new Date(s.ends).getTime()) return null;
  return s;
};

export const withSale = (price, sale) => (sale ? price * (1 - sale.percent / 100) : price);
